module.exports = __webpack_public_path__ + "static/media/about-mission.5dbb610f.webp";